// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*.ant-tree-node-content-wrapper {*/\n/*    line-height: 16px;*/\n/*} !* ant-tree-node-content-wrapper-normal draggable *!*/\n\n.ant-tree li {\n    padding-top: 0;\n    padding-bottom: 0;\n    line-height: 16px;\n}\n.ant-tree-node-content-wrapper {\n    margin-top: 4px;\n    margin-bottom: 4px;\n}\n.ant-tree-child-tree > li:first-child {\n    padding-top: 0px;\n}\n.ant-tree-child-tree > li:last-child {\n    padding-bottom: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
